<template>
  <div class="container">
    <div class="row">
      <div class="mixa-category-container">
        <div
          v-for="categoryInfo in category"
          :key="categoryInfo.title"
          class="detail-container col-md-4"
        >
          <div class="title-container">
            <h3 v-shave="{ height: 110 }">{{ categoryInfo.title }}</h3>
          </div>
          <div class="bottom-container">
            <div class="category-image" @click="navigateTo(categoryInfo.url)">
              <img :title="categoryInfo.title" :src="categoryInfo.image" :alt="categoryInfo.alt" />
            </div>
            <p v-shave="{ height: 120 }">{{ categoryInfo.description }}</p>
            <div v-show="categoryData.ctabuttontext != ''" class="btn-container">
              <a :href="categoryInfo.url" role="button" class="">
                <strong>{{ categoryData.ctabuttontext }}</strong>
              </a>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
        <div class="loadmore">
          <p v-if="categoryData.articles.length > 0" @click="loadMore()">
            {{ categoryData.seeallinktext }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mixa-mag-category',
  props: {
    categoryData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      category: this.categoryData.articles.slice(0, 6),
      remainingCategories: this.categoryData.articles.slice(6),
    };
  },
  methods: {
    loadMore() {
      this.category = [...this.category, ...this.remainingCategories.splice(0, 6)];
    },
    navigateTo(url) {
      window.location.href = url;
      window.eventBus.$emit('TabEventDataLayer', url);
    },
    productDataLayer() {},
  },
};
</script>
